import React, { useRef, useState } from 'react'
import { withApollo, compose } from 'react-apollo'
import { useDispatch, useSelector } from 'react-redux'
import {
  Row,
  Col,
  Card,
  Table,
  Divider,
  Popconfirm,
  Button,
  Input,
  Switch,
  Form,
  Icon
} from 'antd'
import { searchAllLocationByHero, createLocation, updateLocation, deleteLocation, fetchLocationByHero } from '../../../../modules/location'
import { updateHeroConfig, updateHeroRadius } from '../../../../modules/hero'
import { useDeepEffect } from '../../../../utils/hooks'
import Highlighter from 'react-highlight-words'
import ViewMap from './components/ViewMap'
import LocationForm from './components/LocationForm'
import RadiusForm from './components/RadiusForm'
import _, { isEmpty } from 'lodash'
import axios from 'axios'

const Location = (props) => {
  const { heroId, hero, heroConfigs } = props
  const dispatch = useDispatch()
  const [filterOptions, setFilterOptions] = useState({
    heroId: heroId,
    size: 20,
    page: 0
  })
  let searchInput = useRef(null)
  const [visible, setVisible] = useState(false)
  const [visibleRadius, setVisibleRadius] = useState(false)
  const [visibleMap, setVisibleMap] = useState(false)
  const [formData, setFormData] = useState({})
  const [searchText, setSearchText] = useState('')
  const [toggle, setToggle] = useState();

  const { locationList, location, isLoading } = useSelector(
    (state) => ({
      locationList: state.location.locationList,
      location: state.location.location,
      isLoading: state.reports.isLoading
    }),
    []
  )

  async function fetchData() {
    await dispatch(searchAllLocationByHero(filterOptions))
    await dispatch(fetchLocationByHero(heroId))
  }

  useDeepEffect(() => {
    fetchData()
    setToggle(locationList.heroConfig)
  }, [])

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            searchInput = node
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}>
          Search
        </Button>
        <Button
          onClick={() => handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.select())
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  })

  const handleSearch = (selectedKeys, confirm) => {
    confirm()
    setSearchText(selectedKeys[0])
  }

  const handleReset = (clearFilters) => {
    clearFilters()
    setSearchText('')
  }

  const refetchData = async () => { }

  async function onShowSizeChange(current, pageSize) {
    filterOptions.size = pageSize
    filterOptions.page = 0
    setFilterOptions(filterOptions)
    await dispatch(searchAllLocationByHero(filterOptions))
  }

  async function onChange(page) {
    filterOptions.page = page - 1
    setFilterOptions(filterOptions)
    await dispatch(searchAllLocationByHero(filterOptions))
  }

  const onClick = (e, record) => {
    e.preventDefault()
    setVisible(true)
    setFormData(record)
  }
  const onCloseModal = async () => {
    await dispatch(searchAllLocationByHero(filterOptions))
    await setVisible(false)
  }

  const onClickMap = (e) => {
    e.preventDefault()
    setVisibleMap(true)
  }
  const onCloseModalMap = async () => {
    await dispatch(searchAllLocationByHero(filterOptions))
    await setVisibleMap(false)
  }

  const onClickRadius = (e) => {
    e.preventDefault()
    setVisibleRadius(true)
  }
  const onCloseModalRadius = async () => {
    await dispatch(searchAllLocationByHero(filterOptions))
    await setVisibleRadius(false)
  }

  const onDelete = async (id) => {
    await dispatch(deleteLocation(id))
    await dispatch(searchAllLocationByHero(filterOptions))
  }
  const onToggle = (check) => {
    setToggle(check)
    const data = {
      heroId: heroId,
      config: check
    }
    onUpdateConfig(data)
  };

  const onUpdateConfig = async (data) => {
    await dispatch(updateHeroConfig(data))
    await dispatch(fetchLocationByHero(heroId))
  }

  const onUpdateRadius = async (data) => {
    await dispatch(updateHeroRadius(data))
    await dispatch(fetchLocationByHero(heroId))
    await setVisibleRadius(false)
  }

  const onOk = async (data) => {
    if (!_.isEmpty(formData)) {
      await dispatch(updateLocation(data))
    } else {
      await dispatch(createLocation(data))
    }

    await dispatch(searchAllLocationByHero(filterOptions))
    await setVisible(false)
    await setFormData({})
  }

  const columns = [
    {
      title: 'ลำดับ',
      render: (text, record, index) => (
        <span>{filterOptions.page * filterOptions.size + index + 1}</span>
      )
    },
    {

      title: 'ชื่อสถานที่',
      dataIndex: 'name',
      key: 'name',
      ...getColumnSearchProps('name'),
      render: (name, row) => (
        <div>
          {name ? (<Highlighter
            highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={name.toString()} />) : ("")}
        </div>
      )
    },
    {

      title: 'ที่อยู่',
      dataIndex: 'address',
      key: 'address',
      ...getColumnSearchProps('address'),
      render: (address, row) => (
        <div>
          {address ? (<Highlighter
            highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={address.toString()} />) : ("")}
        </div>
      )
    },
    {
      title: 'Location',
      render: (location, record) => <span>{record.lat + " , " + record.lng || '-'}</span>
    },
    {
      title: 'Action',
      key: 'action',
      fixed: 'right',
      width: 100,
      render: (text, record) => (
        <span>
          <Button
            type="primary"
            size="small"
            shape="circle"
            icon="edit"
            onClick={(e) => {
              onClick(e, record)
            }}
          />
          <Divider type="vertical" />
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => onDelete(record.locationId)}>
            <Button type="danger" size="small" shape="circle" icon="delete" />
          </Popconfirm>
        </span>
      )
    }
  ]

  return (
    <Card
      title="Location"
      extra={
        <div>
          <Button size="small" icon="plus" onClick={(e) => onClick(e)}>
            Create Location
          </Button>
          <Button size="small" icon="reload" onClick={() => refetchData()}>
            Reload
          </Button>
        </div>
      }>
      <Row type="flex" gutter={[8, 8]}>
        <Col span={24}>
          <Row style={{ marginBottom: 15 }}>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Row type="flex" justify="space-between" gutter={8} style={{ marginRight: 3, marginLeft: 3 }}>
                <Col>
                  <Switch
                    checkedChildren={true}
                    unCheckedChildren={false}
                    checked={toggle}
                    onChange={onToggle}
                  />
                  {toggle ? (" เปิด - ใช้การตั้งค่าจากสถานที่จาก Hero") : (
                    " ปิด - ใช้การตั้งค่าจากสถานที่จาก Admin Config"
                  )}
                </Col>
                <Col>
                  <Button type="primary" onClick={(e) => onClickMap(e)} >View Map</Button>
                </Col>
              </Row>
              {toggle ? (
                <Row type="flex" justify="space-between" gutter={8} style={{ marginRight: 3, marginLeft: 3 }}>
                  <Col>
                    Radius : <b> {locationList.radius} </b>&nbsp;&nbsp; Max Location : <b> {locationList.maxLocation} </b>&nbsp;&nbsp; <Button type="primary" onClick={(e) => onClickRadius(e)} >แก้ไข Radius</Button>
                  </Col>
                </Row>
              ) : (
                <div></div>
              )}
            </Col>
          </Row>
          <Col span={24}>
            <Table
              rowKey={(record) => {
                return record.id
              }}
              bordered
              dataSource={location.content}
              columns={columns}
              loading={isLoading}
              pagination={{
                current: !isEmpty(location)
                  ? location.pageable.pageNumber + 1
                  : 1,
                pageSize: location.size,
                pageSizeOptions: ['10', '20', '50', '100'],
                showSizeChanger: true,
                onShowSizeChange: onShowSizeChange,
                onChange: onChange,
                total: location.totalElements
              }}
            />
          </Col>
          <RadiusForm
            visible={visibleRadius}
            onOk={onUpdateRadius}
            heroId={heroId}
            onCancel={onCloseModalRadius}
            formData={locationList}
          />
          <LocationForm
            visible={visible}
            onOk={onOk}
            heroId={heroId}
            onCancel={onCloseModal}
            formData={formData}
          />
          <ViewMap
            visible={visibleMap}
            locationList={locationList.locationDto}
            hero={hero}
            heroConfigs={heroConfigs}
            onCancel={onCloseModalMap}
          />
        </Col>
      </Row>
    </Card>
  )
}
export default compose(
  withApollo
)(Location)
